import { AncillaryBaggageInfo } from '@/src/types/itinerary'
import { useTranslations } from 'next-intl'
import Baggage from './baggage'

const BaggageWrapper = ({
    baggageOptions,
    paxCount,
    selectedBaggageOptions,
    handleAddBaggage,
    handleRemoveBaggage,
    formatCurrency
}: {
    baggageOptions: AncillaryBaggageInfo[]
    paxCount: number
    selectedBaggageOptions: AncillaryBaggageInfo[]
    handleAddBaggage: (baggage: AncillaryBaggageInfo) => void
    handleRemoveBaggage: (baggage: AncillaryBaggageInfo) => void
    formatCurrency: (price: number) => string
}) => {
    const t = useTranslations('itineraryPage.addons')
    return (
        <Baggage
            baggageOptions={baggageOptions}
            formatCurrency={formatCurrency}
            paxCount={paxCount}
            selectedBaggageOptions={selectedBaggageOptions}
            handleAddBaggage={handleAddBaggage}
            handleRemoveBaggage={handleRemoveBaggage}
            t={t}
        />
    )
}

export default BaggageWrapper
